import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AdminTable from '../../common/AdminTable';
import { getLiveVideoRequest, deleteLiveVideoRequest } from '../../slice/liveVideoSlice';
import { AiOutlinePlus } from 'react-icons/ai';
import { toast } from 'react-toastify';

const LiveVideoList = () => {
    const dispatch = useDispatch();
    const { liveVideos, loading } = useSelector((state) => state.liveVideo);

    useEffect(() => {
        dispatch(getLiveVideoRequest());
    }, [dispatch]);

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this video?")) {
            dispatch(deleteLiveVideoRequest(id));
            toast.success("Deleting video...");
        }
    };

    const tableHeaders = [
        { Header: 'S.No', accessor: 'id' },
        { 
            Header: 'Source', 
            Cell: ({ row }) => row.original.youtube_url ? <span className="badge badge-info">YouTube</span> : <span className="badge badge-success">File</span>
        },
        { 
            Header: 'Content', 
            Cell: ({ row }) => row.original.youtube_url ? row.original.youtube_url : row.original.video_file 
        },
        { 
            Header: 'Status', 
            Cell: ({ row }) => (
                <span className={`badge ${row.original.status === 'active' ? 'badge-success' : 'badge-danger'}`}>
                    {row.original.status}
                </span>
            )
        },
        {
            Header: 'Actions',
            Cell: ({ row }) => (
                <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row.original.id)}>Delete</button>
                </div>
            )
        }
    ];

    return (
        <div className="container-fluid px-4">
            <div className='d-flex justify-content-between align-items-center my-4'>
                <h2 className='m-0'>Live Videos</h2>
                <Link to="/live-video/add" className='btn btn-primary d-flex align-items-center gap-2'>
                    <AiOutlinePlus /> Add New Video
                </Link>
            </div>

            <div className='card shadow mb-4'>
                <div className='card-body p-0'>
                    {loading ? (
                        <div className="text-center p-5">Loading...</div>
                    ) : (
                        <AdminTable 
                            tableHeaders={tableHeaders} 
                            tableData={liveVideos} 
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default LiveVideoList;
